import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Footer from '../components/Footer'
import { loginUser, getAuthToken } from '../services/authService'
import { useToast } from '../components/ToastProvider'

export default function EmployeeLogin() {
  const navigate = useNavigate()
  const toast = useToast()
  const [formData, setFormData] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    setError('')
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const result = await loginUser(formData.email, formData.password, 'employee')
      toast.success('Login successful!')
      navigate('/employee-dashboard')
    } catch (err) {
      const errorMsg = err.message || 'Login failed. Please try again.'
      setError(errorMsg)
      toast.error(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-white to-saffron-50">
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <button
            onClick={() => navigate('/')}
            className="mb-6 flex items-center text-gray-600 hover:text-gray-900 transition-colors"
          >
            <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            Back to Home
          </button>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="text-center mb-8">
              <img src="/logo.png" alt="igus Logo" className="mx-auto mb-4 h-16 w-auto" />
              <h1 className="text-2xl font-bold text-gray-900">Employee Login</h1>
              <p className="mt-2 text-sm text-gray-600">Enter your company credentials to access your dashboard</p>
            </div>

            <form onSubmit={handleLogin} className="space-y-5">
              <div>
                <label htmlFor="email" className="mb-1 block text-sm font-medium text-gray-700">
                  Company Email
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your.email@igus.net"
                  className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 shadow-sm outline-none focus:border-saffron-500 focus:ring-2 focus:ring-saffron-200"
                  required
                />
              </div>

              <div>
                <label htmlFor="password" className="mb-1 block text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 shadow-sm outline-none focus:border-saffron-500 focus:ring-2 focus:ring-saffron-200"
                  required
                />
              </div>

              {error && (
                <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-lg bg-saffron-600 px-4 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-saffron-700 focus:outline-none focus:ring-2 focus:ring-saffron-500 focus:ring-offset-2 disabled:opacity-50"
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>

            <div className="mt-6 border-t border-gray-200 pt-6">
              <p className="text-xs text-gray-500 text-center">
                <span className="block mb-2">Questions? Contact your administrator</span>
                <span className="font-medium">or visit the</span>
              </p>
              <button
                onClick={() => navigate('/admin')}
                className="w-full mt-2 rounded-lg border border-saffron-300 px-4 py-2.5 text-sm font-medium text-saffron-600 hover:bg-saffron-50 transition-colors"
              >
                Admin Portal
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
